// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"876":"ee1ca9cd","932":"5f846853"}[chunkId] + ".chunk.css";
};